export enum PAGES {
	/**
	 * The container route. Never the active `route.name` at runtime — the
	 * empty-path child takes over immediately — so use it as the module id and
	 * in route config, never in a navigation guard.
	 */
	HOME = 'autogrammetry',
	BROWSE = 'autogrammetry.browse',
	DETAIL = 'autogrammetry.detail',
	COVERAGE = 'autogrammetry.coverage',
	/** One mesh template: its builds, artefacts and review state. */
	MESH = 'autogrammetry.mesh',
	// Named to match the route locations lib/goldenWizard.ts builds.
	GOLDEN_QUEUE = 'autogrammetry.golden.queue',
	GOLDEN_WIZARD = 'autogrammetry.golden.wizard',
}
